import { Typography } from '@mui/material';
import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from 'recharts';

const NoDataAvailable = ({ body, type }) => {
  const placeholderData = [{ name: 'No Data', value: 0 }];

  return (
    <div className="chart-div">
      {body ? <h5 className="text-dark mb-5">{body}</h5> : null}
      {type === 'other' ? (
        <Typography variant="body1" align="center" color="textSecondary">
          No Data Available
        </Typography>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={placeholderData}
            barSize={25}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" tick={{ fontSize: 12 }} />
            <YAxis allowDecimals={false} />
            <Bar dataKey="value" fill="#ddd" />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default NoDataAvailable;
